import React from "react";
const NotificationList = (props) => (
        <>
            {props.notification?.map((value, index) => (
            <a 
                href={
                    value.type == 4 ? `/contact/${value.app_url}` : 
                    value.type == 0 ? `/meeting-details/${value.app_url}` : 
                    value.type == 6 ? `/meeting-details/${value.app_url}` : 
                    value.type == 7 ? `/stories/${value.app_url}` :  
                    `/post/${value.app_url}`
                } 
                className="notification-link-wrapper"
                key={index}
            >
                <div className={`notification-item-modern py-3 border-bottom ${value.read_at == null ? "notification-unread" : "" }`}>
                    <div className="d-flex align-items-center">
                        <div className="notification-avatar position-relative me-3 flex-shrink-0">
                            <div 
                                className="user-picture-container rounded-circle bg-light"
                                style={{
                                    background: `url("${value.avatar}")`,
                                    width: '44px',
                                    height: '44px',
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center'
                                }} 
                            />
                            {value.type === 4 && (
                                <div className="notification-type-icon-colored position-absolute bg-success">
                                    <i className="fa-solid fa-user-plus text-white"/>
                                </div>
                            )}
                            {value.type === 3 && (
                                <div className="notification-type-icon-colored position-absolute bg-primary">
                                    <i className="fa-solid fa-share text-white"/>
                                </div>
                            )}
                            {value.type === 2 && (
                                <div className="notification-type-icon-colored position-absolute bg-primary">
                                    <i className="fa-solid fa-comment text-white"/>
                                </div>
                            )}
                            {value.type === 1 && (
                                <div className="notification-type-icon-colored position-absolute bg-danger">
                                    <i className="fa-solid fa-heart text-white"/>
                                </div>
                            )}
                            {value.type === 0 && (
                                <div className="notification-type-icon-colored position-absolute bg-danger">
                                    <i className="fa-solid fa-video text-white"/>
                                </div>
                            )}
                        </div>
                        
                        <div className="notification-content-modern flex-grow-1 min-w-0">
                            <div className="d-flex align-items-start justify-content-between">
                                <div className="notification-text flex-grow-1 me-2">
                                    <h6 className="notification-title-compact fw-semibold text-dark mb-0 lh-sm">
                                        {value.title}
                                        {value.details && (
                                            <span className="notification-details-inline text-muted fw-normal"> {value.details}</span>
                                        )}
                                    </h6>
                                </div>
                                <div className="notification-meta d-flex align-items-center gap-2">
                                    <span className="notification-time-compact text-muted small">{value.times}</span>
                                    {value.read_at == null && (
                                        <i className="fa-solid fa-circle text-primary" style={{fontSize: '6px'}}/>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
            ))}
            </>
    )

export default React.memo(NotificationList)